// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // PlanTasksWatcherConnectedProps,
  PlanTasksWatcherMapStateReturnType,
} from './types'

export const PlanTasksWatcherMapState = (): // state: StateReducers,
// props: PlanTasksWatcherConnectedProps,
PlanTasksWatcherMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
